export function getOwsPath() {
    return '/owa';
}

export function getOwsPrimePath() {
    return '/ows';
}
